import { createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-618fc7a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "search-container",
  class: "container-fluid position-relative px-0 pt-5 pt-sm-0",
  style: {"max-width":"960px","z-index":"1"}
}
const _hoisted_2 = {
  id: "box-sm",
  class: "text-bg-w-cultured pt-20 pb-25 px-25 rounded-xl",
  style: {"min-height":"163px"}
}
const _hoisted_3 = {
  id: "myTab",
  class: "nav nav-tabs justify-content-center px-0 d-none d-sm-flex gap-20 gap-md-30",
  role: "tablist"
}
const _hoisted_4 = {
  id: "sale-tab",
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = ["aria-selected", "innerHTML"]
const _hoisted_6 = {
  id: "rent-tab",
  class: "nav-item"
}
const _hoisted_7 = ["aria-selected", "innerHTML"]
const _hoisted_8 = {
  key: 0,
  id: "sell-tab",
  class: "nav-item"
}
const _hoisted_9 = ["aria-selected", "innerHTML"]
const _hoisted_10 = {
  key: 1,
  id: "valuation-tab",
  class: "nav-item"
}
const _hoisted_11 = ["aria-selected", "innerHTML"]
const _hoisted_12 = {
  id: "auction-tab",
  class: "nav-item"
}
const _hoisted_13 = ["aria-selected", "innerHTML"]
const _hoisted_14 = {
  id: "agency-tab",
  class: "nav-item"
}
const _hoisted_15 = ["aria-selected", "innerHTML"]
const _hoisted_16 = {
  key: 2,
  id: "trend-tab",
  class: "nav-item"
}
const _hoisted_17 = ["aria-selected", "innerHTML"]
const _hoisted_18 = {
  id: "myTabPane",
  class: "tab-content mt-20"
}
const _hoisted_19 = {
  class: "row bg-white m-0 rounded-xl",
  style: {"min-height":"89px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "vr my-20",
  style: {"border":"1px solid #EAEFFD","opacity":"1"}
}, null, -1 /* HOISTED */))
const _hoisted_21 = {
  key: 0,
  class: "container-dropdown h-100",
  style: {"min-width":"250px"}
}
const _hoisted_22 = { class: "dropdown d-flex h-100 align-items-center" }
const _hoisted_23 = { class: "my-0 divider" }
const _hoisted_24 = {
  ref: "dropdownMenuAgency",
  class: "dropdown-menu opacity-100 w-100"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  type: "button",
  class: "dropdown-item px-25 fw-medium f-14"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "vr my-20",
  style: {"border":"1px solid #EAEFFD","opacity":"1"}
}
const _hoisted_29 = {
  key: 2,
  class: "vr my-20",
  style: {"border":"1px solid #EAEFFD","opacity":"1"}
}
const _hoisted_30 = {
  class: "row bg-white m-0 rounded-xl",
  style: {"min-height":"89px"}
}
const _hoisted_31 = { class: "col d-flex align-items-center ps-25 pe-0" }
const _hoisted_32 = {
  class: "row bg-white m-0 rounded-xl",
  style: {"min-height":"89px"}
}
const _hoisted_33 = { class: "col d-flex align-items-center ps-25 pe-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_listing_typology_multi_select = _resolveComponent("listing-typology-multi-select")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_place_box = _resolveComponent("place-box")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_map_modal = _resolveComponent("map-modal")!
  const _component_filters_agency_modal = _resolveComponent("filters-agency-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("TAB "),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active:_ctx.isActive('sale-tab')}]),
            "data-toggle": "tab",
            "data-field-target": "Contratto",
            role: "tab",
            href: "#filters-tab-pane",
            "aria-selected": _ctx.isActive('sale-tab'),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setActiveTab('sale-tab')), ["prevent"])),
            innerHTML: _ctx.labels.homeSale
          }, null, 10 /* CLASS, PROPS */, _hoisted_5)
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active:_ctx.isActive('rent-tab')}]),
            "data-toggle": "tab",
            "data-field-target": "Contratto",
            role: "tab",
            href: "#filters-tab-pane",
            "aria-selected": _ctx.isActive('rent-tab'),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setActiveTab('rent-tab')), ["prevent"])),
            innerHTML: _ctx.labels.homeRent
          }, null, 10 /* CLASS, PROPS */, _hoisted_7)
        ]),
        _createCommentVNode(" sell tab "),
        (_ctx.sell_tab)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active: _ctx.isSellingActive}]),
                "data-toggle": "tab",
                "data-field-target": "Vendi",
                role: "tab",
                href: "#sell-tab-pane",
                "aria-controls": "sell-tab-pane",
                "aria-selected": _ctx.isSellingActive,
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setActiveTab('sell-tab')), ["prevent"])),
                innerHTML: _ctx.labels.sell
              }, null, 10 /* CLASS, PROPS */, _hoisted_9)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.valuation_tab)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active: _ctx.isValuationActive}]),
                "data-toggle": "tab",
                "data-field-target": "Valuta",
                role: "tab",
                href: "#valuation-tab-pane",
                "aria-controls": "valuation-tab-pane",
                "aria-selected": _ctx.isValuationActive,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setActiveTab('valuation-tab')), ["prevent"])),
                innerHTML: _ctx.labels.valuate
              }, null, 10 /* CLASS, PROPS */, _hoisted_11)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active:_ctx.isActive('auction-tab')}]),
            "data-toggle": "tab",
            "data-field-target": "Contratto",
            role: "tab",
            href: "#filters-tab-pane",
            "aria-selected": _ctx.isActive('auction-tab'),
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setActiveTab('auction-tab')), ["prevent"])),
            innerHTML: _ctx.labels.auction
          }, null, 10 /* CLASS, PROPS */, _hoisted_13)
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active: _ctx.isAgencyActive}]),
            "data-toggle": "tab",
            "data-field-target": "Tipologia",
            role: "tab",
            href: "#filters-tab-pane",
            "aria-selected": _ctx.isSearchActive,
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setAgencyTabActive && _ctx.setAgencyTabActive(...args)), ["prevent"])),
            innerHTML: _ctx.labels.agencies
          }, null, 10 /* CLASS, PROPS */, _hoisted_15)
        ]),
        (_ctx.trend_tab)
          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link f-16 bg-w-cultured", {active: _ctx.isTrendActive}]),
                "data-toggle": "tab",
                href: "#filters-tab-pane",
                role: "tab",
                "aria-controls": "trend-tab-pane",
                "aria-selected": _ctx.isTrendActive,
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.setActiveTab('trend-tab')), ["prevent"])),
                innerHTML: _ctx.labels.trend
              }, null, 10 /* CLASS, PROPS */, _hoisted_17)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode("TAB CONTENT"),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          id: "filters-tab-pane",
          class: _normalizeClass(["tab-pane fade", { 'active show': _ctx.isSearchActive || _ctx.isTrendActive || _ctx.isAgencyActive}]),
          role: "tabpanel"
        }, [
          _createElementVNode("div", _hoisted_19, [
            (_ctx.isSearchActive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["col-auto col-md-3 px-0 d-flex", {'mb-lg-0':_ctx.not_found}]),
                  style: {"min-height":"89px"}
                }, [
                  _createVNode(_component_listing_typology_multi_select, {
                    id: "listingTypology",
                    "model-value": _ctx.searchBean.listingTypologyIdList,
                    name: "TipologiaListato",
                    "class-name": "f-12 fake-input home-input form-control-sm",
                    "ltms-btn-classes": "w-100",
                    listing: false,
                    "force-close": _ctx.forceCloseMultiTypology,
                    "macro-typology-id": _ctx.searchBean.macroTypologyId,
                    "macro-typology-id-list": _ctx.searchBean.macroTypologyIdList,
                    "listing-typologies": _ctx.listingTypologies,
                    "arrow-color": "gs",
                    onClick: _ctx.closePlaceDropdown,
                    onInputObject: _ctx.onLTMSChange
                  }, null, 8 /* PROPS */, ["model-value", "force-close", "macro-typology-id", "macro-typology-id-list", "listing-typologies", "onClick", "onInputObject"]),
                  _hoisted_20
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" TODO: deve essere trasformato in un componente vue"),
            _createElementVNode("div", {
              class: _normalizeClass(["col d-flex pe-0 align-items-center", {'ps-25':_ctx.isTrendActive,'ps-0':_ctx.isAgencyActive}])
            }, [
              (_ctx.isAgencyActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        id: "dropdown-toggle-agency",
                        ref: "dropdownToggleAgency",
                        class: "btn btn-block btn-search-box f-16 text-start text-truncate fw-medium dropdown-toggle",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "data-bs-auto-close": "outside",
                        "data-bs-offset": "0,0",
                        "aria-expanded": "false",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closePlaceDropdown && _ctx.closePlaceDropdown(...args)))
                      }, " Gruppo - " + _toDisplayString(_ctx.agencyLabel), 513 /* TEXT, NEED_PATCH */),
                      _withDirectives(_createElementVNode("hr", _hoisted_23, null, 512 /* NEED_PATCH */), [
                        [_vShow, false]
                      ]),
                      _createElementVNode("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions('franchiseList'), (franchise) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: franchise.id,
                            onClick: ($event: any) => (_ctx.selectedGroupAgency(franchise))
                          }, [
                            _createElementVNode("button", _hoisted_26, [
                              _createElementVNode("span", {
                                innerHTML: franchise.label
                              }, null, 8 /* PROPS */, _hoisted_27)
                            ])
                          ], 8 /* PROPS */, _hoisted_25))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isAgencyActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                : _createCommentVNode("v-if", true),
              _createElementVNode("form", {
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
              }, [
                (_ctx.isAgencyActive)
                  ? (_openBlock(), _createBlock(_component_base_input, {
                      key: 0,
                      id: "valuationAddressDesktop",
                      modelValue: _ctx.agencyFilter.name,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.agencyFilter.name) = $event)),
                      placeholder: "Agenzia",
                      border: false,
                      onFocusin: _cache[9] || (_cache[9] = ($event: any) => {_ctx.closeAgencyFranchiseList();_ctx.closePlaceDropdown();})
                    }, null, 8 /* PROPS */, ["modelValue"]))
                  : _createCommentVNode("v-if", true)
              ], 32 /* HYDRATE_EVENTS */),
              (_ctx.isAgencyActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_place_box, {
                "close-drop-down": _ctx.forceClosePlace,
                "has-error": _ctx.hasSearchError,
                "place-types": _ctx.placeTypes,
                place: _ctx.place,
                listing: false,
                "is-agency": _ctx.isAgencyActive,
                "show-place-map-drop-down": !_ctx.isTrendActive,
                "contract-type": _ctx.isTrendActive ? 'trend' : '',
                onFocus: _ctx.closeMultiListingTypology,
                onFocusIn: _ctx.closeMultiListingTypology,
                onShowMap: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openModal('MAP'))),
                onEmitPlace: _ctx.getPlaceFromModal
              }, null, 8 /* PROPS */, ["close-drop-down", "has-error", "place-types", "place", "is-agency", "show-place-map-drop-down", "contract-type", "onFocus", "onFocusIn", "onEmitPlace"]),
              _createVNode(_component_base_button, {
                id: "home-desktop-search-btn",
                "data-cy": "search-btn-desktop",
                "btn-class": "btn-w-primary position-absolute",
                style: {"right":"20px"},
                disabled: !_ctx.isSearchReady,
                "is-loading": _ctx.isSearchLoading,
                onClick: _withModifiers(_ctx.handleSearch, ["stop","prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labels.genericSearch), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "is-loading", "onClick"])
            ], 2 /* CLASS */)
          ])
        ], 2 /* CLASS */),
        (_ctx.valuation_tab)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "valuation-tab-pane",
              class: _normalizeClass(["tab-pane fade", { 'active show': _ctx.isValuationActive}]),
              role: "tabpanel"
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_place_box, {
                    listing: false,
                    valuation: true,
                    "has-error": _ctx.hasValuationError,
                    onNewPlace: _ctx.handleValuation,
                    onFocus: _ctx.closeMultiListingTypology,
                    onFocusIn: _ctx.closeMultiListingTypology
                  }, null, 8 /* PROPS */, ["has-error", "onNewPlace", "onFocus", "onFocusIn"]),
                  _createVNode(_component_base_button, {
                    id: "home-desktop-valuate-btn",
                    "data-cy": "valuate-btn",
                    "btn-class": "btn-w-primary px-0 position-absolute",
                    disabled: !_ctx.isValuationReady,
                    "is-loading": _ctx.isValuationLoading,
                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.valuationRedirect(false)), ["prevent","stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.labels.valuate), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "is-loading"])
                ])
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (_ctx.sell_tab)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "sell-tab-pane",
              class: _normalizeClass(["tab-pane fade", { 'active show': _ctx.isSellingActive}]),
              role: "tabpanel"
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_place_box, {
                    listing: false,
                    valuation: true,
                    "has-error": _ctx.hasValuationError,
                    onNewPlace: _ctx.handleValuation,
                    onFocus: _ctx.closeMultiListingTypology,
                    onFocusIn: _ctx.closeMultiListingTypology
                  }, null, 8 /* PROPS */, ["has-error", "onNewPlace", "onFocus", "onFocusIn"]),
                  _createVNode(_component_base_button, {
                    id: "home-desktop-selling-btn",
                    "data-cy": "selling-btn",
                    "btn-class": "btn-w-primary px-0 position-absolute",
                    disabled: !_ctx.isValuationReady,
                    "is-loading": _ctx.isSellingLoading,
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.valuationRedirect(true)), ["prevent","stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.labels.sell), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "is-loading"])
                ])
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    (_ctx.modal == 'MAP')
      ? (_openBlock(), _createBlock(_component_map_modal, {
          key: 0,
          "show-map-modal": true,
          listing: false,
          onHideMapModal: _ctx.closeModal,
          onEmitPlace: _ctx.getPlaceFromMapModal
        }, null, 8 /* PROPS */, ["onHideMapModal", "onEmitPlace"]))
      : (_ctx.modal === 'FILTERS_AGENCY_MODAL')
        ? (_openBlock(), _createBlock(_component_filters_agency_modal, {
            key: 1,
            "show-filters-agency-modal": true,
            onHideAgencyFilterModal: _ctx.closeModal,
            onFilterAgencyModal: _ctx.saveFilterAgency
          }, null, 8 /* PROPS */, ["onHideAgencyFilterModal", "onFilterAgencyModal"]))
        : _createCommentVNode("v-if", true)
  ]))
}